(() => {
  angular.module('finance').component('netsuiteConfigurationTransactionCategoryItemAccountCode', {
    templateUrl: require('./transactionCategoryItemAccountCode.component.html'),
    controller: NetSuiteTransactionCategoryItemAccountCodesController,
    controllerAs: 'vm'
  });

  NetSuiteTransactionCategoryItemAccountCodesController.$inject = [
    '$scope',
    'abp.services.finance.netSuite',
    'financeConstants',
    '$uibModal'
  ];

  function NetSuiteTransactionCategoryItemAccountCodesController(
    $scope,
    netSuiteSvc,
    financeConstants,
    $uibModal
  ) {
    const vm = this;

    vm.loading = 0;

    vm.requestParams = {
      skipCount: 0,
      maxResultCount: financeConstants.grid.defaultPageSize,
      sorting: null
    };

    vm.transactionCategoryItemAccountCodesGridOptions = {
      appScopeProvider: vm,
      paginationPageSizes: financeConstants.grid.defaultPageSizes,
      paginationPageSize: financeConstants.grid.defaultPageSize,
      paginationCurrentPage: 1,
      useExternalPagination: true,
      useExternalSorting: true,
      columnDefs: [
        {
          name: App.localize('Actions'),
          displayName: 'Actions',
          enableSorting: false,
          width: 100,
          headerCellTemplate: '<span></span>',
          cellTemplate: 'transactionCategoryItemAccountCodeActionTemplate',
          allowCellFocus: false,
        },
        {
          displayName: App.localize('AccountCode'),
          field: 'accountCode',
          minWidth: 120,
        },
        {
          displayName: App.localize('InternalId'),
          field: 'internalId',
          minWidth: 120,
        },
      ],
      onRegisterApi(gridApi) {
        $scope.gridApi = gridApi;
        gridApi.pagination.on.paginationChanged(
          $scope,
          App.setPagination(
            vm.requestParams, getTransactionCategoryItemAccountCodes)
        );gridApi.core.on.sortChanged($scope, (grid, sortColumns) => {
          if (!sortColumns.length) {
            vm.requestParams.sorting = null;
          } else {
            vm.requestParams.sorting = `${sortColumns[0].field} ${sortColumns[0].sort.direction}`;
          }
          getTransactionCategoryItemAccountCodes();
        });
      },
      data: [],
    };

    vm.getTransactionCategoryItemAccountCodes = getTransactionCategoryItemAccountCodes;
    vm.createTransactionCategoryItemAccountCode = createTransactionCategoryItemAccountCode;
    vm.deleteTransactionCategoryItemAccountCode = deleteTransactionCategoryItemAccountCode;

    init();

    function init() {
      getTransactionCategoryItemAccountCodes();
    }

    function getTransactionCategoryItemAccountCodes() {
      vm.loading += 1;
      netSuiteSvc
        .getTransactionCategoryItemAccountCodes(vm.requestParams)
        .success(data => {
          vm.transactionCategoryItemAccountCodesGridOptions.totalItems = data.totalCount;
          vm.transactionCategoryItemAccountCodesGridOptions.data = data.items;
        })
        .finally(() => {
          vm.loading -= 1;
        });
    }

    function createTransactionCategoryItemAccountCode() {
      $uibModal
        .open({
          templateUrl: require('./createTransactionCategoryItemAccountCode.modal.html'),
          controller: 'createNetSuiteTransactionCategoryItemAccountCode as vm',
          backdrop: 'static'
        })
        .result.then(() => {
          getTransactionCategoryItemAccountCodes();
        });
    }

    function deleteTransactionCategoryItemAccountCode(transactionCategoryItemAccountCode) {
      abp.message.confirm(
        App.localize('TransactionCategoryItemAccountCodeDeleteWarningMessage', transactionCategoryItemAccountCode.accountCode),
        App.localize('AreYouSure'),
        (d) => {
          if (d) {
            vm.loading += 1;
            netSuiteSvc
              .deleteTransactionCategoryItemAccountCode(
                { id: transactionCategoryItemAccountCode.id }
              )
              .success(() => {
                abp.notify.success(App.localize('SuccessfullyDeleted'));
              })
              .finally(() => {
                vm.loading -= 1;
                getTransactionCategoryItemAccountCodes();
              });
          }
        }
      );
    }
  }
})();
